import React, { useState, useRef, useEffect } from 'react';
import cl from './Popover.module.css' 

const Popover = ({ children, content, placement = 'top' , fullWidth }) => {
  const [isVisible, setIsVisible] = useState(false);
  const popoverRef = useRef(null);
  const triggerRef = useRef(null);


  let  buttonWidth = cl.dInline

  if(fullWidth == true) {
      buttonWidth = cl.dBlock
  }

  let  posPopover = cl.popoverTop 
  if (placement === 'top') {
      posPopover = cl.popoverTop
  } else if (placement === 'bottom') {
      posPopover = cl.popoverBottom
  } else if (placement === 'left') {
      posPopover = cl.popoverLeft
  } else if (placement === 'right') {
      posPopover = cl.popoverRight 
  }



  // Close the popover explicitly
  const closePopover = () => {
    setIsVisible(false);
  };

  // This effect handles clicking outside of the popover or trigger to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target) &&
          triggerRef.current && !triggerRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <span style={{ position: 'relative' }} className={ buttonWidth }> 
      <span ref={triggerRef} onClick={() => setIsVisible(!isVisible)} style={{ cursor: 'pointer' }} className={ buttonWidth }>
        {children}
      </span>
      {isVisible && (
        <div ref={popoverRef} className={cl.popoverBox + ' ' + posPopover } style={{ position: 'absolute' }}>
          {React.cloneElement(content, { closePopover })}
        </div>
      )}
    </span>
  );
};

export default Popover;
